export const supportTranslations = {
  // List page
  title: "ศูนย์ช่วยเหลือ",
  subtitle: "รับความช่วยเหลือจากทีม Zaviago และติดตามคำขอของคุณได้ที่นี่",
  newRequest: "เปิดคำขอใหม่",
  searchPlaceholder: "ค้นหาคำขอ…",
  filterAll: "ทั้งหมด",
  filterActive: "กำลังดำเนินการ",
  updatedAgo: "อัปเดตเมื่อ {{time}}",
  newReply: "มีการตอบกลับใหม่",
  emptyNoTicketsTitle: "ยังไม่มีคำขอความช่วยเหลือ",
  emptyNoTicketsDesc:
    "เมื่อคุณต้องการความช่วยเหลือ เปิดคำขอไว้ แล้วทีม Zaviago จะติดต่อกลับที่นี่",
  emptyNoMatchTitle: "ไม่มีคำขอที่ตรงกับตัวกรองนี้",
  emptyNoMatchDesc: "ลองเปลี่ยนตัวกรองหรือล้างคำค้นหา",

  // Floating widget
  widgetGreeting: "เราช่วยอะไรได้บ้าง?",
  widgetGreetingSub: "โดยปกติเราตอบกลับภายในไม่กี่นาที",
  widgetViewAll: "เปิดหน้าช่วยเหลือแบบเต็ม",
  widgetLauncher: "ช่วยเหลือ",
  widgetNewReplyToast: "ทีมช่วยเหลือตอบกลับคำขอของคุณแล้ว",

  // View switcher
  viewList: "รายการ",
  viewBoard: "บอร์ด",
  viewCalendar: "ปฏิทิน",
  calendarToday: "วันนี้",
  calendarMore: "+ อีก {{count}}",

  // Presence strip
  presenceOnline: "ทีมช่วยเหลือออนไลน์",
  presenceReplyTime: "โดยปกติตอบกลับภายในไม่กี่นาที",
  presenceCountOnline: "ออนไลน์ {{count}} คน",
  presenceAvgReply: "ตอบกลับเฉลี่ย ~{{mins}} นาที",
  presence247: "ให้บริการ 24 ชม.",
  presenceSecondsAgo: "ใช้งานล่าสุด {{sec}} วินาทีที่แล้ว",
  presenceJustNow: "ใช้งานเมื่อสักครู่",

  // Status labels
  statusOpen: "เปิด",
  statusInProgress: "กำลังดำเนินการ",
  statusWaiting: "รอคุณตอบกลับ",
  statusResolved: "แก้ไขแล้ว",
  statusClosed: "ปิดแล้ว",

  // Priority labels
  priorityLow: "ต่ำ",
  priorityMedium: "ปานกลาง",
  priorityHigh: "สูง",
  priorityUrgent: "ด่วน",

  // Category labels
  categoryBilling: "การเงิน/ใบเสร็จ",
  categoryTechnical: "ปัญหาการใช้งาน",
  categoryBug: "ข้อผิดพลาดของระบบ",
  categoryFeatureRequest: "ขอฟีเจอร์ใหม่",
  categoryOther: "อื่น ๆ",

  // Compose page
  composeTitle: "เปิดคำขอความช่วยเหลือใหม่",
  composeSubtitle: "ทีม Zaviago จะตอบกลับ และคุณติดตามได้ตลอดเวลา",
  cancel: "ยกเลิก",
  sendRequest: "ส่งคำขอ",
  subjectLabel: "หัวข้อ",
  subjectPlaceholder: "คุณต้องการความช่วยเหลือเรื่องอะไร?",
  detailsLabel: "รายละเอียด",
  categoryLabel: "หมวดหมู่",
  priorityLabel: "ความสำคัญ",
  descriptionLabel: "อธิบายปัญหา",
  descriptionPlaceholder:
    "อธิบายปัญหาที่พบ สิ่งที่คุณคาดหวัง และแนบภาพหน้าจอหรือคลิปวิดีโอได้ ใช้แถบเครื่องมือด้านบนเพื่อเพิ่มรูปภาพหรือวิดีโอ",
  descriptionTip: "เคล็ดลับ: ใช้ปุ่มรูปภาพและวิดีโอเพื่อแนบภาพหน้าจอหรือคลิปวิดีโอ",

  // Rich composer toolbar
  toolbarBold: "ตัวหนา",
  toolbarItalic: "ตัวเอียง",
  toolbarUnderline: "ขีดเส้นใต้",
  toolbarBulletList: "รายการหัวข้อย่อย",
  toolbarNumberedList: "รายการลำดับเลข",
  toolbarInsertImage: "แทรกรูปภาพ",
  toolbarInsertVideo: "แทรกวิดีโอ",

  // Page context (auto-attached)
  contextTitle: "รายงานจากหน้านี้",
  contextHint:
    "หากปัญหาอยู่คนละหน้า กรุณาไปที่หน้านั้นก่อนกดส่ง เราจะแนบหน้าที่คุณดูอยู่ เพื่อให้เราเห็นสิ่งที่คุณเห็น",
  contextReportedFrom: "รายงานจากหน้า",
  entityProduct: "สินค้า",
  entityOrder: "คำสั่งซื้อ",
  entityCustomer: "ลูกค้า",
  entityPage: "หน้าปัจจุบัน",

  // Knowledge-base deflection (compose)
  kbTitle: "บทความที่อาจช่วยได้",

  // CSAT (after resolve)
  csatQuestion: "เรื่องนี้ช่วยแก้ปัญหาของคุณได้ไหม?",
  csatYes: "ช่วยได้ ขอบคุณ",
  csatNo: "ยังไม่ช่วย",
  csatThanks: "ขอบคุณสำหรับความคิดเห็น",

  // Activity timeline
  timelineResolved: "ทำเครื่องหมายว่าแก้ไขแล้ว",
  timelineReopened: "เปิดเรื่องอีกครั้ง",

  // Conversation UX (customer)
  agentTyping: "ทีมช่วยเหลือกำลังพิมพ์…",
  sending: "กำลังส่ง…",
  sent: "ส่งแล้ว",
  seen: "ทีมงานเห็นแล้ว",
  sendFailed: "ส่งไม่สำเร็จ",
  retry: "ลองใหม่",
  estResponse: "ทีมงานมักตอบภายใน ~{{mins}} นาที",
  replyToMessage: "ตอบกลับ",
  replyingTo: "กำลังตอบกลับ",
  quickNotFixed: "ยังไม่ได้รับการแก้ไข",
  quickThanks: "ขอบคุณครับ",
  quickMoreInfo: "ขอสอบถามเพิ่มเติม",
  dateToday: "วันนี้",
  dateYesterday: "เมื่อวาน",

  // Detail page
  backToSupport: "กลับไปหน้าช่วยเหลือ",
  notFound: "ไม่พบคำขอนี้",
  reopen: "เปิดใหม่",
  markResolved: "ทำเครื่องหมายว่าแก้ไขแล้ว",
  openedAgo: "เปิดเมื่อ {{time}}",
  agentName: "ทีมช่วยเหลือ Zaviago",
  replyPlaceholder: "เขียนข้อความตอบกลับ…",
  sendHint: "⌘/Ctrl + Enter เพื่อส่ง",
  send: "ส่ง",
};
